(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/xperten-systems.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/xperten-systems.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.XpertenSystems = Backbone.Model.extend({
    defaults: {
      system: [
        { size: 4, full: 0, half: 2, isExtended: false },
        { size: 8, full: 0, half: 3, isExtended: true },
        { size: 12, full: 1, half: 2, isExtended: false },
        { size: 16, full: 0, half: 4, isExtended: true },
        { size: 24, full: 1, half: 3, isExtended: false },
        { size: 27, full: 3, half: 0, isExtended: true },
        { size: 32, full: 0, half: 5, isExtended: true },
        { size: 36, full: 2, half: 2, isExtended: false },
        { size: 48, full: 1, half: 4, isExtended: true },
        { size: 64, full: 0, half: 6, isExtended: false },
        { size: 72, full: 2, half: 3, isExtended: true },
        { size: 81, full: 4, half: 0, isExtended: true },
        { size: 96, full: 1, half: 5, isExtended: true },
        { size: 108, full: 3, half: 2, isExtended: true },
        { size: 128, full: 0, half: 7, isExtended: false },
        { size: 144, full: 2, half: 4, isExtended: true },
        { size: 192, full: 1, half: 6, isExtended: false },
        { size: 216, full: 3, half: 3, isExtended: true },
        { size: 243, full: 5, half: 0, isExtended: true },
        { size: 256, full: 0, half: 8, isExtended: false },
        { size: 288, full: 2, half: 5, isExtended: true },
        { size: 324, full: 4, half: 2, isExtended: true },
        { size: 384, full: 1, half: 7, isExtended: true },
        { size: 432, full: 3, half: 4, isExtended: true },
        { size: 486, full: 5, half: 1, isExtended: true },
        { size: 512, full: 0, half: 9, isExtended: false },
        { size: 576, full: 2, half: 6, isExtended: true },
        { size: 648, full: 4, half: 3, isExtended: true },
        { size: 768, full: 1, half: 8, isExtended: true },
        { size: 864, full: 3, half: 5, isExtended: true },
        { size: 972, full: 5, half: 2, isExtended: true },
        { size: 1024, full: 0, half: 10, isExtended: true },
        { size: 1152, full: 2, half: 7, isExtended: true },
        { size: 1296, full: 4, half: 4, isExtended: true },
        { size: 1458, full: 6, half: 1, isExtended: true },
        { size: 1536, full: 1, half: 9, isExtended: true },
        { size: 1728, full: 3, half: 6, isExtended: true },
        { size: 1944, full: 5, half: 3, isExtended: true },
        { size: 2048, full: 0, half: 11, isExtended: true },
        { size: 2187, full: 7, half: 0, isExtended: true },
        { size: 2304, full: 2, half: 8, isExtended: true },
        { size: 2592, full: 4, half: 5, isExtended: true },
        { size: 2916, full: 6, half: 2, isExtended: true },
        { size: 3072, full: 1, half: 10, isExtended: true },
        { size: 3456, full: 3, half: 7, isExtended: true },
        { size: 3888, full: 5, half: 4, isExtended: true },
        { size: 4096, full: 0, half: 12, isExtended: true },
        { size: 4374, full: 7, half: 1, isExtended: true },
        { size: 4608, full: 2, half: 9, isExtended: true },
        { size: 5184, full: 4, half: 6, isExtended: true },
        { size: 5832, full: 6, half: 3, isExtended: true },
        { size: 6144, full: 1, half: 11, isExtended: true },
        { size: 6561, full: 8, half: 0, isExtended: true },
        { size: 6912, full: 3, half: 8, isExtended: true },
        { size: 7776, full: 5, half: 5, isExtended: true },
        { size: 8192, full: 0, half: 13, isExtended: true },
        { size: 8748, full: 7, half: 2, isExtended: true },
        { size: 9216, full: 2, half: 10, isExtended: true }
      ],
      systemEightMatches: [
        { size: 2, full: 0, half: 1 },
        { size: 4, full: 0, half: 2 },
        { size: 8, full: 0, half: 3 },
        { size: 16, full: 0, half: 4 },
        { size: 32, full: 0, half: 5 },
        { size: 54, full: 3, half: 1 },
        { size: 64, full: 0, half: 6 },
        { size: 81, full: 4, half: 0 },
        { size: 108, full: 3, half: 2 }
      ],
      systemR: [
        {
          size: 36,
          type: 'R',
          full: 7,
          half: 0,
          rows: 36,
          guaranty: 11,
          mg: 1,
          systemNum: 28
        },
        {
          size: 81,
          type: 'R',
          full: 8,
          half: 0,
          rows: 81,
          guaranty: 11,
          mg: 1,
          systemNum: 29
        },
        {
          size: 222,
          type: 'R',
          full: 9,
          half: 0,
          rows: 222,
          guaranty: 11,
          mg: 1,
          systemNum: 30
        },
        {
          size: 567,
          type: 'R',
          full: 10,
          half: 0,
          rows: 567,
          guaranty: 11,
          mg: 1,
          systemNum: 31,
          isLong: true
        },
        {
          size: 729,
          type: 'R',
          full: 11,
          half: 0,
          rows: 729,
          guaranty: 11,
          mg: 1,
          systemNum: 32,
          isLong: true
        }
      ],
      singleRows: [
        { size: 1 },
        { size: 2 },
        { size: 3 },
        { size: 4 },
        { size: 5 },
        { size: 6 },
        { size: 7 },
        { size: 8 },
        { size: 9 },
        { size: 10 },
        { size: 11 },
        { size: 12 }
      ],
      hasBaseRow: false,
      useBoardRow: false,
      showExtended: false,
      isRsystem: false,
      baseRow: '',
      quickPick: svs.tipset.constants.NO_QP,
      generateSystem: false
    },

    setData: function() {
      this.listenTo(
        svs.tipset.models.play,
        'change:isSingleRow',
        this.clearAll
      );
      var isRsystem =
          svs.tipset.models.systems.getCurrentSystem() &&
          svs.tipset.models.systems.getCurrentSystem().type ==
            svs.tipset.constants.SYSTEM_TYPE.R_SYSTEM,
        nrOfMatches = svs.tipset.models.gameDefinitions.get('numberOfMatches'),
        systemsToShow = isRsystem
          ? this.getRsystem()
          : this.getSystems(nrOfMatches),
        hasBaseRow = !svs.tipset.models.play.get('isSingleRow')
          ? svs.tipset.collections.matchlist.getHasMarksSetByUser()
          : false;

      this.set({
        systemsToShow: systemsToShow,
        isRsystem: isRsystem,
        useBoardRow: hasBaseRow,
        hasExtended:
          svs.tipset.models.gameDefinitions.get('numberOfMatches') > 8 &&
          !isRsystem &&
          !svs.tipset.models.play.get('isSingleRow'),
        hasBaseRow: hasBaseRow,
        generateSystem: false
      });

      this.setIsValid(this.get('systemsToShow'));
    },

    getCompetitionXpert: function() {
      if (
        svs.tipset.models.competition &&
        svs.tipset.models.competition.getCompetitionMode() &&
        svs.tipset.models.competition.getCompetitionSystem()
      ) {
        var system = _.findWhere(
          this.getSystems(
            svs.tipset.models.gameDefinitions.get('numberOfMatches')
          ),
          { size: svs.tipset.models.competition.getCompetitionSystem().rows }
        );
        this.setCurrentSystem(system);
        this.getSystem();
      }
    },

    getSystems: function(noOfMatches) {
      var tmpObj;
      if (svs.tipset.models.play.get('isSingleRow')) {
        tmpObj = this.toJSON().singleRows;
      } else if (noOfMatches === 13) {
        tmpObj = this.toJSON().system;
      } else {
        tmpObj = this.toJSON().systemEightMatches;
      }
      return tmpObj;
    },

    getRsystem: function() {
      return this.toJSON().systemR;
    },

    getBombenSystems: function() {
      return this.toJSON().bombenSystem;
    },

    setCurrentSystem: function(system) {
      this.setIsClicked(system);
      this.set('currentSystem', system, { silent: true });
    },

    url: function() {
      var useBaseRow = this.getUseBoardRow(),
        newUrl = '/wager/xpertwagers/',
        productApiName = svs.tipset.models.gameDefinitions.getAPIName(
          svs.tipset.collections.draws.getCurrentDraw().get('productId')
        ),
        baseRowStr = '',
        baseRowData = svs.tipset.collections.matchlist.getBaseRow();
      this.setQP();
      if (useBaseRow && baseRowData) {
        baseRowStr =
          '&baseRow=' +
          svs.tipset.utils.convertBoardToItsData(
            svs.tipset.collections.matchlist.getBaseRow()
          );
      }
      newUrl += productApiName + this.getXpertenSystemString() + baseRowStr;

      return svs.core.jupiter.url() + newUrl;
    },

    getXpertenSystemString: function() {
      var sysStr = '',
        system = this.getCurrentSystem();
      if (system && system.type == 'R') {
        sysStr = '&systemType=' + system.type + 'SYS';
      }

      if (svs.tipset.models.play.get('isSingleRow')) {
        return '?systemType=SROW&numRows=' + system.size;
      }
      return '?systemSize=' + system.size + sysStr;
    },

    getCurrentSystem: function() {
      return this.get('currentSystem');
    },

    parse: function(response) {
      if (response.wager && response.wager.bets) {
        this.listenToOnce(
          svs.tipset.collections.matchlist,
          'xpertBoardDataIsSet',
          this.setListeners
        );
        return response.wager.bets[0];
      }
    },

    setListeners: function() {
      if (!this.get('generateSystem')) {
        this.listenToOnce(
          svs.tipset.collections.matchlist,
          'buttonBet',
          this.setQpModified
        );
      }
    },

    setQpModified: function() {
      this.setQP({ isModified: true });
    },

    getXpertBoardData: function() {
      return this.get('game1X2Boards');
    },

    getSystem: function() {
      this.stopListening(
        svs.tipset.collections.matchlist,
        'buttonBet',
        this.setQpModified
      );
      if (!this.get('generateSystem')) {
        this.fetch();
      } else {
        this.trigger('generateSystem');
      }
      this.trigger('toggleContextMenu');
    },

    generateSystem: function() {
      this.set('generateSystem', false, { silent: true });
      this.getSystem();
    },

    setUseBoardRow: function(useBoardRow) {
      if (!useBoardRow) {
        this.set('baseRow', '', { silent: true });
      }
      this.set('useBoardRow', useBoardRow, { silent: true });
      this.set(
        'generateSystem',
        useBoardRow && !svs.tipset.collections.matchlist.getHasMarksSetByUser(),
        { silent: true }
      );
    },

    getUseBoardRow: function() {
      return this.get('useBoardRow');
    },

    getBaseRow: function() {
      return svs.tipset.collections.matchlist.isAnySet()
        ? svs.tipset.utils.convertBoardToItsData(
          svs.tipset.collections.matchlist.getBoardData()
        )
        : '';
    },

    clearAll: function() {
      this.stopListening(
        svs.tipset.collections.matchlist,
        'buttonBet',
        this.setQpModified
      );
      this.setCurrentSystem(null);
      this.set('hasBaseRow', false, { silent: true });
      this.set('baseRow', '', { silent: true });
      this.setUseBoardRow(false);
      this.set('generateSystem', false, { silent: true });
      this.set('quickPick', svs.tipset.constants.NO_QP);
      this.trigger('resetXperten');
      this.trigger('toggleContextMenu');
    },

    setIsClicked: function(currentSystem) {
      _.each(this.get('systemsToShow'), function(system) {
        if (
          currentSystem &&
          currentSystem.size &&
          system.size == currentSystem.size
        ) {
          system.isClicked = true;
        } else {
          system.isClicked = false;
        }
      });
    },

    setIsValid: function(inSystemsToValidate) {
      var nrOfHalfHedges =
          svs.tipset.collections.matchlist &&
          svs.tipset.collections.matchlist.getNrOfHalfHedgesSetByUser()
            ? svs.tipset.collections.matchlist.getNrOfHalfHedgesSetByUser()
            : 0,
        nrOfFullHedges =
          svs.tipset.collections.matchlist &&
          svs.tipset.collections.matchlist.getNrOfFullHedgesSetByUser()
            ? svs.tipset.collections.matchlist.getNrOfFullHedgesSetByUser()
            : 0,
        systemsToValidate =
          inSystemsToValidate ||
          this.getSystems(
            svs.tipset.models.gameDefinitions.get('numberOfMatches')
          ),
        isCompetition =
          svs.tipset.models.competition &&
          svs.tipset.models.competition.getCompetitionMode(),
        self = this;
      _.each(systemsToValidate, function(system) {
        if (self.getUseBoardRow()) {
          if (system.half >= nrOfHalfHedges && system.full >= nrOfFullHedges) {
            if (isCompetition) {
              system.isValid =
                system.size === svs.tipset.constants.M_SYSTEM.M_64;
            } else {
              system.isValid = true;
            }
          } else {
            system.isValid = false;
          }
        } else {
          if (isCompetition) {
            system.isValid = system.size === svs.tipset.constants.M_SYSTEM.M_64;
          } else {
            system.isValid = true;
          }
        }
      });
    },

    setQP: function(options) {
      var isModified =
          options && options.isModified ? options.isModified : false,
        useBaseRow = this.getUseBoardRow(),
        qp = useBaseRow
          ? svs.tipset.constants.QP_BASEROW
          : svs.tipset.constants.QP_NO_BASEROW;

      if (isModified) {
        qp = svs.tipset.constants.QP_MODIFIED;
      }

      this.set('quickPick', qp);
    },

    showActionbar: function() {
      var hasSystem = this.getCurrentSystem() != undefined,
        isNotModified =
          this.get('quickPick') != svs.tipset.constants.QP_MODIFIED,
        showActionBar = this.get('generateSystem');

      if (!this.get('generateSystem')) {
        showActionBar = hasSystem && isNotModified;
      }

      return showActionBar;
    },

    reloadXperten: function() {
      this.generateSystem();
    }
  });
})(Backbone, _, svs);

 })(window);